export class Params {
    constructor() {
        this.JobTitle = [];
        this.GradeBucket = [];
        this.JobCategoryCode = [];
        this.JobCategoryFamily = [];
        this.LocationName = [];
        this.Department = [];
        this.Agency = [];
        this.PositionOfferingTypeCode = [];
        this.TravelPercentage = [];
        this.PositionScheduleTypeCode = [];
        this.SecurityClearanceRequired = [];
        this.PositionSensitivity = [];
        this.ShowAllFilters = [];
        this.HiringPath = [];
        this.SocTitle = [];
        this.MCOTags = [];
        this.CyberWorkRole = [];
        this.CyberWorkGrouping = [];
        this.JobGradeCode = [];
    }
    Keyword?: string;
    JobTitle: string[];
    RemunerationMinimumAmount?: string;
    RemunerationMaximumAmount?: string;
    GradeBucket: string[];
    JobCategoryCode: string[];
    JobCategoryFamily: string[];
    LocationName: string[];
    Department: string[];
    Agency: string[];
    PositionOfferingTypeCode: string[];
    TravelPercentage: string[];
    PositionScheduleTypeCode: string[];
    RelocationIndicator?: string | boolean | null;
    TeleworkIndicator?: string | boolean | null;
    RemoteIndicator?: string | boolean | null;
    SecurityClearanceRequired: string[];
    PositionSensitivity: string[];
    JobGradeCode: string[];
    SortField?: string;
    SortDirection?: string;
    Page?: string;
    ShowAllFilters: string[];
    GradeSearch?: boolean;
    SavedSearchID?: number;
    SavedSearchName?: string;
    Radius?: string;
    EmailFrequency?: string;
    HiringPath: string[];
    CustomWhoMayApply?: string;
    UniqueSearchID?: string;
    SocTitle: string[];
    DocumentID?: number;
    URL?: string;
    ResultsPerPage?: number;
    IsAuthenticated?: boolean;
    MCOTags: string[];
    CyberWorkRole: string[];
    CyberWorkGrouping: string[];
    CustomMcoTag?: string;
    IncludeInternal?: boolean;
    TotalResults?: number;
}

export function DefaultExistingParams(existingParam: Params):Params {
    if (!existingParam.JobTitle) { existingParam.JobTitle = [] }
    if (!existingParam.GradeBucket) { existingParam.GradeBucket = [] }
    if (!existingParam.JobCategoryCode) { existingParam.JobCategoryCode = [] }
    if (!existingParam.JobCategoryFamily) { existingParam.JobCategoryFamily = [] }
    if (!existingParam.LocationName) { existingParam.LocationName = [] }
    if (!existingParam.Department) { existingParam.Department = [] }
    if (!existingParam.Agency) { existingParam.Agency = [] }
    if (!existingParam.PositionOfferingTypeCode) { existingParam.PositionOfferingTypeCode = [] }
    if (!existingParam.TravelPercentage) { existingParam.TravelPercentage = [] }
    if (!existingParam.PositionScheduleTypeCode) { existingParam.PositionScheduleTypeCode = [] }
    if (!existingParam.SecurityClearanceRequired) { existingParam.SecurityClearanceRequired = [] }
    if (!existingParam.PositionSensitivity) { existingParam.PositionSensitivity = [] }
    if (!existingParam.ShowAllFilters) { existingParam.ShowAllFilters = [] }
    if (!existingParam.HiringPath) { existingParam.HiringPath = [] }
    if (!existingParam.SocTitle) { existingParam.SocTitle = [] }
    if (!existingParam.MCOTags) { existingParam.MCOTags = [] }
    if (!existingParam.CyberWorkRole) { existingParam.CyberWorkRole = [] }
    if (!existingParam.CyberWorkGrouping) { existingParam.CyberWorkGrouping = [] }
    if (!existingParam.JobGradeCode) { existingParam.JobGradeCode = [] }

    return existingParam;
}

export class Preference {
    constructor(type: string, value: string | boolean) {
        this.Type = type;
        this.Value = value;
    }
    Type: string;
    Value: string | boolean;
}
